<template>
  <div class="account-profile-heading__wrapper">
    <div class="avatar-wrapper">
      <VAvatar
        v-if="firstName && lastName"
        :firstName="firstName"
        :lastName="lastName"
        :clickable="false"
        useInitials
      ></VAvatar>
    </div>

    <div class="info-block">
      <div class="name">
        <span class="cred"> {{ firstName }} {{ lastName }} </span>
        <VBadge label="Contact"> </VBadge>
      </div>
      <div class="contact-description">
        <span>
          <i class="fa fa-map-marker-alt"></i> {{ city }},
          {{ country }}
        </span>
        <span>
          <VTime :startTime="contactTime" />
        </span>

        <span v-if="deliverable && verification.verification_status">
          <img :src="verifiedImg" alt="verified" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import moment from "moment-timezone";

import VAvatar from "@/components/VAvatar";
import VBadge from "@/components/VBadge";
import VTime from "@/components/VTime";

import verifiedImg from "@/assets/images/verified.svg";
import { getGravatarUrl } from "@/utils/util";

export default Vue.component("AccountProfileHeading", {
  props: {
    firstName: VueTypes.string,
    lastName: VueTypes.string,
    city: VueTypes.string,
    country: VueTypes.string,
    verification: VueTypes.object,
    deliverable: VueTypes.bool
  },

  data() {
    return {
      verifiedImg
    };
  },

  components: {
    VAvatar,
    VBadge,
    VTime
  },

  computed: {
    contactTime() {
      return this.verification && this.verification.details
        ? moment()
            .utc()
            .add(Number(this.verification.details.utc_offset), "h")
            .add(Number(this.verification.details.dst), "h")
        : undefined;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "account-profile-heading";

.#{$ns} {
  &__wrapper {
    display: flex;
    align-items: center;

    .avatar-wrapper {
      margin-right: 15px;
    }

    .info-block {
      flex: 0 1 auto;
      line-height: 1.3;

      > div {
        font-size: 14px;

        &.name {
          display: flex;
          align-items: center;
          font-size: 22px;
          margin-bottom: 3px;

          .cred {
            margin-right: 15px;
          }
        }
      }
    }

    .contact-description {
      display: flex;
      align-items: center;

      span {
        display: flex;
        align-items: center;
        margin-right: 20px;
        font-weight: 700;

        i {
          margin-right: 5px;
          color: $secondary-text-color;
        }
      }
    }
  }
}
</style>
